import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { baseUrl } from "../utilities/configurations";
import { useNavigate } from "react-router-dom";
import apiRequest from "../utilities/request";
import PropTypes from "prop-types";

const ReimbursementRequestContext = createContext();

export function useReimbursementRequestContext() {
  return useContext(ReimbursementRequestContext);
}

export function ReimbursementRequestProvider(props) {
  const initForm = {
    opMedicinePrescription: null,
    isHospitalNotInList: false,
    opticalPrescription: null,
    medicalCertificate: null,
    isDoctorNotInList: false,
    statementOfAccount: null,
    dentalCertificate: null,
    officialReceipt: null,
    selectedPolicy: null,
    admissionDate: null,
    dischargeDate: null,
    termsChecked: false,
    policeReport: null,
    chargeSlip: null,
    claimAmount: "",
    hospital: null,
    claimType: "",
    doctor: null
  };

  const [isGettingHospitals, setIsGettingHospitals] = useState(false);
  const [isGettingDoctors, setIsGettingDoctors] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [viewModalShown, setViewModalShown] = useState(false);
  const [displayAlert, setDisplayAlert] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [allHospitals, setAllHospitals] = useState([]);
  const [formData, setFormData] = useState(initForm);
  const [uploadField, setUploadField] = useState("");
  const [base64File, setBase64File] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [errorField, setErrorField] = useState("");
  const [allDoctors, setAllDoctors] = useState([]);
  const [loadState, setLoadState] = useState("");
  const [hospitals, setHospitals] = useState([]);
  const [openField, setOpenField] = useState("");
  const [fileName, setFileName] = useState("");
  const [doctors, setDoctors] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getHospitals();
  }, []);

  const getHospitals = async () => {
    try {
      setIsGettingHospitals(true);
      const res = await apiRequest(baseUrl + `/LOA/Providers`, "GET");
      if (!res.error) {
        setAllHospitals(res.data || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsGettingHospitals(false);
    }
  };

  const data = useMemo(
    () => ({
      setIsGettingHospitals,
      setIsGettingDoctors,
      setShowUploadModal,
      setViewModalShown,
      setDisplayAlert,
      setIsCameraOpen,
      setErrorMessage,
      setCurrentStep,
      setUploadField,
      setErrorField,
      setBase64File,
      setAllDoctors,
      setLoadState,
      setOpenField,
      setHospitals,
      setFormData,
      setFileName,
      setDoctors,
      navigate,

      isGettingHospitals,
      isGettingDoctors,
      showUploadModal,
      viewModalShown,
      errorMessage,
      allHospitals,
      isCameraOpen,
      displayAlert,
      currentStep,
      uploadField,
      errorField,
      base64File,
      allDoctors,
      openField,
      loadState,
      hospitals,
      formData,
      fileName,
      doctors
    }),
    [
      isGettingHospitals,
      isGettingDoctors,
      showUploadModal,
      viewModalShown,
      errorMessage,
      allHospitals,
      displayAlert,
      isCameraOpen,
      currentStep,
      uploadField,
      errorField,
      base64File,
      allDoctors,
      openField,
      loadState,
      hospitals,
      formData,
      fileName,
      doctors
    ]
  );

  return (
    <ReimbursementRequestContext.Provider value={data}>
      {props.children}
    </ReimbursementRequestContext.Provider>
  );
}

ReimbursementRequestProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
